module.exports = __webpack_public_path__ + "static/img/exportbanner.316b541.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/exportbanner.png
// module id = a3NK
// module chunks = 10